import * as React from "react";
import { Button as BaseButton } from "baseui/button";

const Button = (props) => {
  return (
    <BaseButton {...props} />
  );
}
export default Button;